import React, { useState } from 'react';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase'; // Import your Firebase db instance
import NavbarAdmin from '../components/NavbarAdmin';

const AddJobStaff = () => {
  const [statistics2, setStatistics2] = useState({
    titre: '',
    lien: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStatistics2({ ...statistics2, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'job_staff'), {
        ...statistics2,
        timestamp: Timestamp.now()
      });
      console.log("Document successfully written!");
      setStatistics2({
        titre: '',
        lien: ''
      });
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  const containerStyle = {
    padding: '20px',
    maxWidth: '800px',
    margin: '0 auto',
    fontFamily: 'Arial, sans-serif',
  };

  const headingStyle = {
    fontSize: '2rem',
    color:  '#6699CC',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0',
    textAlign: 'center',
    borderBottom: '2px solid #ddd',
    paddingBottom: '10px',
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    margin: '0 auto',
    maxWidth: '600px',
  };

  const inputStyle = {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    width: '100%',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#6699CC',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '1rem',
    cursor: 'pointer',
  };

  return (
    <div>
      <NavbarAdmin />
      <div style={containerStyle}>
        <h2 style={headingStyle}>Ajouter Un Recrutement Staff</h2>
        <form onSubmit={handleSubmit} style={formStyle}>
          <label>
            Titre :
            <input
              type="text"
              name="titre"
              value={statistics2.titre}
              onChange={handleInputChange}
              required
              style={inputStyle}
            />
          </label>
          <label>
            Lien Drive :
            <input
              type="text"
              name="lien"
              value={statistics2.lien}
              onChange={handleInputChange}
              required
              style={inputStyle}
            />
          </label>
          <button type="submit" style={buttonStyle}>Ajouter</button>
        </form>
      </div>
    </div>
  );
};

export default AddJobStaff;
